import React from 'react';
import { Loader2 } from 'lucide-react';

const Loader = ({ message, className = '', loaderStyle }) => {
    return (
        <div className={`flex flex-col items-center justify-center gap-3 py-10 ${className}`}>
            <Loader2 className={`w-10 h-10 text-blue-500 shrink-0 animate-spin ${loaderStyle}`} />
            {
                message &&
                <p className="text-sm text-gray-600 text-center font-medium">{message}</p>
            }
        </div>
    );
};

export default Loader;
